import { render } from "./MPPayment.vue?vue&type=template&id=2072335b"
import script from "./MPPayment.vue?vue&type=script&lang=js"
export * from "./MPPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__